export const TRANSPORT_ORDER_ROUTE = '/transport-orders';
export const SERVICE_ORDER_ROUTE = '/service-orders';
export const WELCOME_ROUTE = '/welcome';
export const SERVICE_PROVIDER_ACTIVATION_ROUTE = '/service-providers';
export const COMPOUND_MANAGEMENT_ROUTE = '/compound-management';
export const OOB_INSPECTOR_ROUTE = '/inspector';

export const routes = [
    WELCOME_ROUTE,
    TRANSPORT_ORDER_ROUTE,
    SERVICE_ORDER_ROUTE,
    SERVICE_PROVIDER_ACTIVATION_ROUTE,
    COMPOUND_MANAGEMENT_ROUTE,
    OOB_INSPECTOR_ROUTE,
];
